"use client"

import * as React from "react"
import { cn } from "cn"
import { ScrollArea as ScrollAreaPrimitive } from "radix-ui"

function ScrollArea({
  className,
  children,
  ...props
}: React.ComponentProps<typeof ScrollAreaPrimitive.Root>) {
  return (
    <ScrollAreaPrimitive.Root
      data-slot="scroll-area"
      className={cn("relative", className)}
      {...props}
    >
      {/* Radix 는 Viewport 의 자식을 `display: table` 래퍼로 감싼다(인라인 style 이라 `!` 로만 이긴다).
          table 은 내용의 min-content 폭까지 늘어나므로 안의 nowrap 한 줄(`truncate` 한 줄)이
          페이지 전체를 그 줄만큼 넓힌다 — 좁은 화면에서 말줄임도 `flex-wrap` 도 일어나지 않는다.
          block 으로 눌러 페이지 폭이 뷰포트를 따르게 한다. 표는 자체 `overflow-x-auto` 래퍼가 있어 영향이 없다.
          생성물을 다시 받으면 이 한 조각을 되살린다. */}
      <ScrollAreaPrimitive.Viewport
        data-slot="scroll-area-viewport"
        className="size-full rounded-[inherit] transition-[color,box-shadow] outline-none focus-visible:ring-1 focus-visible:ring-ring/50 focus-visible:outline-1 [&>div]:block!"
      >
        {children}
      </ScrollAreaPrimitive.Viewport>
      <ScrollBar />
      {/* 가로 스크롤바가 없으면 Radix 가 뷰포트에 overflow-x: hidden 을 걸어
          좁은 화면에서 넘친 내용이 스크롤도 되지 않고 잘린다 — 생성물을 다시 받으면 이 줄을 되살린다. */}
      <ScrollBar orientation="horizontal" />
      <ScrollAreaPrimitive.Corner />
    </ScrollAreaPrimitive.Root>
  )
}

function ScrollBar({
  className,
  orientation = "vertical",
  ...props
}: React.ComponentProps<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>) {
  return (
    <ScrollAreaPrimitive.ScrollAreaScrollbar
      data-slot="scroll-area-scrollbar"
      orientation={orientation}
      className={cn(
        "flex touch-none p-px transition-colors select-none",
        orientation === "vertical" &&
          "h-full w-2.5 border-l border-l-transparent",
        orientation === "horizontal" &&
          "h-2.5 flex-col border-t border-t-transparent",
        className
      )}
      {...props}
    >
      <ScrollAreaPrimitive.ScrollAreaThumb
        data-slot="scroll-area-thumb"
        className="relative flex-1 rounded-full bg-border"
      />
    </ScrollAreaPrimitive.ScrollAreaScrollbar>
  )
}

export { ScrollArea, ScrollBar }
